import axios from 'axios';
import { Message } from 'element-ui';

var querystring = require("querystring")
var crypto = require("crypto")

var environment = "pro"
// pro真是环境
// test测试环境
var bug = true

class Util {


  config() {


    const confproth = [
      /*河南丹东文化配置*/
      {
        prothName: "系统管理平台", proth: "4", host: "private.sumou.fun", loginUrl: "getcode_admin_login", url: 'https://privateserver.sumou.fun'

      }, {
        prothName: "服务商作业平台", proth: "1", host: "houteserver.sumou.fun", loginUrl: "code_login", url: 'https://privateserver.sumou.fun'

      },

      {
        prothName: "代理作业平台", proth: "3", host: "agent.hout.sumou.fun", loginUrl: "agent_code_login", url: 'https://privateserver.sumou.fun'

      },

      /*四川代理公司配置*/
      {
        prothName: "系统管理平台", proth: "4", host: "admin.jiudianfuwuqi.com", loginUrl: "getcode_admin_login", url: 'https://api.jiudianfuwuqi.com'

      }, {
        prothName: "服务商作业平台", proth: "1", host: "prive.jiudianfuwuqi.com", loginUrl: "code_login", url: 'https://api.jiudianfuwuqi.com'
      },

      {
        prothName: "代理作业平台", proth: "3", host: "server.jiudianfuwuqi.com", loginUrl: "agent_code_login", url: 'https://api.jiudianfuwuqi.com'

      },

      // admin.jiudianfuwuqi.com  系统管理平台
      // houteserver.sumou.fun 服务商作业平台
      // agent.hout.sumou.fun 代理作业平台






      //       prive.jiudianfuwuqi.com

      // admin.jiudianfuwuqi.com

      // server.jiudianfuwuqi.com

      /*本地测试*/
      {
        prothName: "系统管理平台", proth: "4", host: "127.0.0.1", loginUrl: "getcode_admin_login", url: 'https://privateserver.sumou.fun'

      }, {
        prothName: "服务商作业平台", proth: "1", host: "localhost", loginUrl: "code_login", url: 'https://privateserver.sumou.fun'

      },

      {

        prothName: "代理作业平台", proth: "3", host: "192.168.110.100", loginUrl: "agent_code_login", url: 'https://privateserver.sumou.fun'

        // prothName: "代理作业平台", proth: "3", host: "192.168.110.100", loginUrl: "agent_code_login", url: 'http://192.168.110.100:4787'

      }

    ]
    var server = ""
    var wsurl = ""
    var proth
    var loginUrl
    var prothName
    var serverUrl
    // var serverUrl = "https://privateserver.sumou.fun"
    var testserverUrl = "http://192.168.110.100:4787"

    for (var confprothKey in confproth) {
      if (location.href.indexOf(confproth[confprothKey].host) != - 1) {
        proth = confproth[confprothKey].proth
        prothName = confproth[confprothKey].prothName
        loginUrl = confproth[confprothKey].loginUrl
        serverUrl = confproth[confprothKey].url
      }

    }

    if (environment == "test") {
      server = testserverUrl
    } else {
      server = serverUrl

    }

    /**
     * 3 代理端
     * 4 平台
     * 1 服务商
     */
    window.proth = {
      environment: environment, prothName: prothName, static: "https://file.sumou.fun", server: server, proth: proth, wsurl: wsurl, loginUrl: loginUrl,
    }

    return window.proth

  }

  async get_oem(menu) {
    const response = await this.get_no("houte", "oem", { domain: menu })
    // console.log(response,'responseresponseresponse');
    var res_data = this.redata(response)

    return res_data

  }


  async get_field(menu) {
    return await this.post("admin", "get_field", { id: menu })

  }


  async get_field_module(module) {
    return await this.post("admin", "get_field_module", { module: module })
  }


  redata(str) {
    //1、去掉前两个字符
    let str1 = str.substring(2, str.length)
    //2、把第三第四个字符转成10进制
    let num = str1.substring(0, 2)
    num = parseInt(num, 8)

    //3、把数字作为下标去掉前面的字符
    var str2 = str1.substring(num + 2, str1.length)
    //4、剩下字符串取前16位为秘钥
    var key = str2.substring(0, 16)
    //5、解密剩下字符串
    var data = str2.substring(16, str2.length)

    var info = this.decryption(data, key)
    return JSON.parse(info)
  }

  async wxget(data) {
    var url = "http://" + this.get_cookie("sendurl") + ":4891"
    var responst = await axios.get(url, data, {})
    return responst
  }

  async post(se, fun, data, not, value) {
    // console.log(value, 'valuevalue');

    this.config()
    var loding = document.getElementsByClassName("loading")

    if (loding.length > 0) {
      loding[0].style.display = "flex"
    }

    if (!data) {
      data = {}
    }

    var _this = this

    data.sg = new Date().getTime().toString(8)
    data.sgin = crypto.createHash('md5').update(JSON.stringify(data)).digest('hex');
    var key = this.randomWord(16, 16)
    var sum = parseInt(Math.random() * (20 - 10 + 1) + 10, 10)
    var sgdata = this.randomWord(sum, sum)
    var info = JSON.stringify(data)
    return new Promise((r, e) => {
      var request_data = data
      if (bug) {
        // console.log(data._ + " " + se + " " + fun + " request data --->", JSON.parse(JSON.stringify(data)))
        request_data.bug = true
      } else {

        request_data = { _: Buffer.from(sum.toString(8) + sgdata + key + this.encryption(info, key), 'binary') }
      }
      request_data._ = request_data._


      axios.post(this.config().server + "/" + se + "/" + fun, request_data, {
        timeout: 60000, headers: {
          // server:'houte',
          sgin: data.sgin,

          prothrole: _this.config().proth || "",
          proth: "WEB",
          module: _this.get_cookie("module") || "public",
          server: !value ? _this.get_cookie("server") || "server" : value,
          modulenames: encodeURIComponent(_this.get_cookie("table_name") || ""),
          identifying: _this.get_cookie("identifying") || "",
          authorization: _this.get_cookie("AUTH") || "",
        }
      })
        .then(function (response) {
          if (loding.length > 0) {
            loding[0].style.display = "none"
          }
          try {
            var res_data = JSON.parse(_this.decryption(response.data.substring(18, response.data.length), response.data.substring(2, 18)))
            //打开debug 大于返回内容
            if (bug) {
              // console.log(se + " " + fun + "  response data <---", res_data)
            }
            if (res_data.sgin != data.sgin || res_data.requestid != data.sg) { //签名验证不通过或者请求ID对不上则不返回内容
              _this.error("意外请求")
              r(false)
              return
            }
            console.log(res_data,'res_datares_datares_data');
            if (res_data.code != 200) { //签名验证不通过
              _this.error(res_data.message)
              r(false)
              return
            } else {
              r(res_data.data)
            }
          } catch (e) {
            console.log(e)
          }
        })
        .catch(function (error) {
          console.log(error)
          if (loding.length > 0) {
            loding[0].style.display = "none"
          }
          try {
            if (error.response.status == 402 && !not) { //登录过期
              if (location.href.indexOf("adminindex") != - 1 || location.href.indexOf("adminhome") != - 1) {
                location.href = "/#/adminlogin"
              } else {
                location.href = "/#/login"
              }
            }
          } catch (e) {

          }

          r(false)
        });

    })
  }

  setCookie(name, val, min) {
    var now = new Date();
    //设置时间
    now.setMinutes(now.getMinutes() + min)

    //设置Cookie
    document.cookie = name + '=' + val + ';expires=' + now.toUTCString()
  }

  async get(se, fun, data) {

    axios.get(this.config().server + se + "/" + fun + "?" + querystring.stringify(data), request_data, {
      headers: {}
    })
      .then(function (response) {
        r(response.data)
      })
      .catch(function (error) {
        r(false)
      });

  }

  async get1(se, fun, data) {

    try {
      const response = await axios.get(
        this.config().server + se + "/" + fun + "?" + querystring.stringify(data.data),
        {
          headers: {}
        }
      );
      return response.data;
    } catch (error) {
      console.error("请求失败:", error);
      return false;
    }

  }
  async get_no(se, fun, data) {

    return new Promise((r, e) => {
      var request_data = data

      console.log(this.config().server + "/" + se + "/" + fun + "?" + querystring.stringify(data))
      axios.get(this.config().server + "/" + se + "/" + fun + "?" + querystring.stringify(data), request_data, {
        headers: {
          sgin: "", authorization: ""
        }
      })
        .then(function (response) {

          try {

            r(response.data)
          } catch (e) {
            console.log(e)
          }
        })
        .catch(function (error) {
          r(false)
        });

    })
  }

  encryption(data, key, iv) {
    var cipherChunks = [];
    var cipher = crypto.createCipheriv('aes-128-cbc', key, "0123456789abcdef");
    cipher.setAutoPadding(true);
    cipherChunks.push(cipher.update(data, 'utf8', 'base64'));
    cipherChunks.push(cipher.final('base64'));
    return cipherChunks.join('');
  }


  decryption(data, key, iv) {
    var cipherChunks = [];
    var decipher = crypto.createDecipheriv('aes-128-cbc', key || "Q85Wc34a6W945Wcf", iv || "0123456789abcdef");
    decipher.setAutoPadding(true);
    cipherChunks.push(decipher.update(data, 'base64', 'utf8'));
    cipherChunks.push(decipher.final('utf8'));
    return cipherChunks.join('');
  }

  randomWord(min, max) {
    var str = "", range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    range = Math.round(Math.random() * (max - min)) + min;
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  }


  get_cookie(name) {
    var ck = document.cookie
    var array = ck.split(";")

    for (var i = 0; i < array.length; i++) {
      var obj = array[i];

      var ck = obj.split("=")
      if (ck[0].indexOf(name) != - 1) {
        return ck[1]
      }

    }

  }

  getCookie(cookieName) {
    const strCookie = document.cookie
    const cookieList = strCookie.split(';')

    for (let i = 0; i < cookieList.length; i++) {
      const arr = cookieList[i].split('=')
      if (cookieName === arr[0].trim()) {
        return arr[1]
      }
    }

    return ''
  }

  formatDateTime(obj, time) {
    var date;
    if (time) {
      date = new Date(time);
    } else {
      date = new Date()
    }
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? ('0' + minute) : minute;
    var second = date.getSeconds();
    second = second < 10 ? ('0' + second) : second;
    if (obj == 1) {
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    }
    if (obj == 2) {
      return y + '-' + m + '-' + d;
    }
    if (obj == 3) {
      return h + ':' + minute + ':' + second;
    }
    if (obj == 4) {
      return date.getTime();
    }
    if (obj == 5) {
      return minute + ':' + second;
    }
    if (obj == 6) {
      return h + ':' + minute;
    }
    if (obj == 7) {
      return "" + y + m + d + h + minute + second + date.getMilliseconds();
    }
    if (obj == 8) {
      return y + '年' + m + '月' + d + '日';
    }
    if (obj == 9) {
      var day = date.getDay();
      var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
      var week = weeks[day];
      return week;

    }
    if (obj == 10) {
      return m + '-' + d;

    }
  }

  error(str) {
    Message.error(str)
    return
  }

  alert(str) {
    Message.success(str)
    return
  }

  randomWord(min, max) {
    var str = "", range = min,
      arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    range = Math.round(Math.random() * (max - min)) + min;
    for (var i = 0; i < range; i++) {
      var pos = Math.round(Math.random() * (arr.length - 1));
      str += arr[pos];
    }
    return str;
  }


  getSHA(str) {
    var obj = crypto.createHash('sha1');//与java的SHA加密方式生成的密钥相同
    obj.update(str);
    str = obj.digest('hex');//hex是十六进制
    return str;
  }

  async agentConfig() {
    return new Promise(async (r, e) => {
      try {
        var timestamp = parseInt((+ new Date()) / 1000)
        var nonceStr = this.randomWord(20, 20)
        var ticket = await this.post("users", "getJsApiTicket")
        var signature = this.getSHA(`jsapi_ticket=${ticket.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${location.href.split("#/")[0]}`)
        console.log(`jsapi_ticket=${ticket.ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${location.href.split("#/")[0]}`)
        wx.agentConfig({
          grouid: ticket.grouid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: ticket.agentid, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature,// 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ['selectExternalContact', "selectEnterpriseContact", "openAppManage", "selectCorpGroupContact", "openEnterpriseChat"], //必填，传入需要使用的接口名称
          success: function (res) {
            r(true)
          }, fail: function (res) {
            console.log("ERROR", res)
            r(false)
          }
        });
      } catch (e) {
        console.log(e)
        r(false)
      }
    })
  }

  select_user(mode, type, fromDepartmentId, selectedUserIds, selectedDepartmentIds) {

    return new Promise((r, e) => {
      wx.invoke("selectEnterpriseContact", {
        debug: false, "fromDepartmentId": fromDepartmentId,// 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
        "mode": mode,// 必填，选择模式，single表示单选，multi表示多选
        "type": type,// 必填，选择限制类型，指定department、user中的一个或者多个
        "selectedDepartmentIds": selectedDepartmentIds || [],// 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        "selectedUserIds": selectedUserIds || [],// 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
      }, async function (res) {

        if (res.err_msg == "selectEnterpriseContact:ok") {
          if (typeof res.result == 'string') {
            res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
          }
          r(res.result.userList)
        } else {
          r(false)
        }
      });
    })
  }

  isPhone(phone) {
    var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(phone)) {
      return false;
    } else {
      return true;
    }
  }


  sort_data(data, value) {

    for (var i = 0; i < data.length; i++) {

      if (data[i].value === value) {
        return data[i]
      }

    }

  }


  getMonthBetween(start, end) {


    var result = [];
    //使用传入参数的时间
    var startTime = new Date(start);
    var endTime = new Date(end);
    while (endTime - startTime >= 0) {
      let year = startTime.getFullYear();
      let month = startTime.getMonth();
      month = month < 9 ? '0' + (month + 1) : month + 1;
      let day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
      //加入数组
      result.push(year + "-" + month + "-" + day);
      //更新日期
      startTime.setDate(startTime.getDate() + 1);
    }
    return result;

  }
}

export default new Util()



// WEBPACK FOOTER //
// ./src/assets/js/util.js